import MLink from '@mui/material/Link';
import { makeStyles } from 'tss-react/mui';
import DirectionsIcon from '@mui/icons-material/Directions';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WeekendIcon from '@mui/icons-material/Weekend';
import InlineMarkdown from '../inline-markdown';
import { getMapQuery, getMapUrl } from './map-url';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  nameHidden: {
    marginLeft: theme.spacing(0.5),
    fontStyle: 'italic',
  },
  mainIcon: {
    flexShrink: 0,
    marginRight: theme.spacing(0.5),
  },
  meta: {},
  details: {
    fontStyle: 'italic',
  },
  mapLink: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(0.5),
  },
  mapIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
}));

type Props = {
  event?: Event;
  type: 'start' | 'end';
  [key: string]: unknown;
};

const EventLocation = ({ event, type, ...rest }: Props) => {
  const { classes } = useStyles();

  const name = type === 'start' ? event.startLocation : event.endLocation;
  const address = type === 'start' ? event.startLocationAddress : event.endLocationAddress;
  const details = type === 'start' ? event.startLocationDetails : event.endLocationDetails;
  const { eventType, permissions } = event;

  // don't return null if not approved and type is start so we can say location hidden
  if (!name && !address && (permissions.approved || type !== 'start')) {
    return null;
  }

  const mapUrl = getMapUrl(getMapQuery(name, address));

  return (
    <div {...rest} className={classes.root}>
      {type === 'end'
        ? <WeekendIcon className={classes.mainIcon} />
        : <LocationOnIcon className={classes.mainIcon}/>}
      <div>
        <div>
          {eventType === 'RIDE' && (type === 'start' ? 'Start: ' : 'End: ')}
          {permissions.approved ? name : <span className={classes.nameHidden}>Location hidden</span>}
        </div>
        {permissions.approved && (
          <div className={classes.meta}>
            {address && <div>{address}</div>}
            {details && (
              <div className={classes.details}>
                <InlineMarkdown>{details}</InlineMarkdown>
              </div>
            )}
            <MLink href={mapUrl} className={classes.mapLink}>
              <DirectionsIcon className={classes.mapIcon} />
              Open Map
            </MLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventLocation;
